export function defaultResponseHandler(response) {
    return response?.data?.data
}

export function rootDataResponseHandler(response) {
    return response?.data
}
